import { useCallback, useRef, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import MediaService from '../../services/MediaService'
import UnitNavigation from '../../components/Navigation/UnitNavigation'
import Surprise from '../../components/World/Surprise/Surprise'
import { GetUserVideo, getVideo } from '../../s3Func/s3Download'

const Module5Nav = () => {
	const { module5 } = useSelector((state) => state.module5, shallowEqual)
	const { login } = useSelector((state) => state.loginReducer, shallowEqual)

	/*****************
	 *  BG Image Logic
	 * ***************/

	const [displaySurprise, setDisplaySurprise] = useState(false)
	const [surpriseConfig, setSurpriseConfig] = useState(null)
	const bgImage = useRef()

	const checkScreenSize = () => {
		const desktopImage = '/Module5Images/Module5NavImages/Background.png'
		const mobileImage = '/Module5Images/Module5NavImages/M5_Path_Mobile.png'

		bgImage.current =
			window.screen && window.screen.width < 1025 ? mobileImage : desktopImage
	}

	const resizeListener = useCallback(() => {
		window.addEventListener(
			'resize',
			(event) => checkScreenSize(event.target),
			true
		)
	}, [])

	resizeListener()
	checkScreenSize()

	const backgroundPath =
		bgImage.current && MediaService.getImage(bgImage.current, login)
	const worldBG = MediaService.getImage(
		'/Module5Images/Module5NavImages/Background.png',
		login
	)

	/*****************
	 *  Day Logic
	 * ***************/

	const getDayConfig = useCallback((dayNumber) => {
		let filledImageUrl = `/Module5Images/Module5NavImages/JourneyMap_Day${dayNumber}.png`
		let outlinedImageUrl = `/Module5Images/Module5NavImages/JourneyMap_Outline_Day${dayNumber}.png`

		// Use the trophy image from module1
		if (dayNumber === 9) {
			outlinedImageUrl = '/Module1Images/Module1NavImages/Outline_Day9.png'
			filledImageUrl = '/Module1Images/Module1NavImages/Color_Day9.png'
		}

		return {
			dayNumber,
			destiny: '/distance',
			filledImageUrl,
			outlinedImageUrl,
		}
	}, [])

	const daysArray = [...Array(9).keys()]
	const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1))

	const SURPRISE_VIDEO = {
		video: '7f4a4280b9c7eaaf4c215094f69a/480.m3u8',
		song: 'appfiles/distance/distance_student_instrumental.m4a',
		slides: [
			`influencers/${login.influencerid}/close_affirmation.mp4`,
			`userfiles/${module5.StudentID}/distance_celebration_surprise_5.mp4`,
			`userfiles/${module5.StudentID}/distance_smile.jpg`,
			`influencers/${login.influencerid}/distance_video_message.mp4`,
			`userfiles/${module5.StudentID}/distance_celebration_surprise_8.mp4`,
			`userfiles/${module5.StudentID}/distance_silly_photo_1.jpg`,
			`userfiles/${module5.StudentID}/distance_celebration_surprise_9.mp4`,
		],
	}

	const handleSurpriseClick = async () => {
		let { slides, song, video } = SURPRISE_VIDEO

		slides = await Promise.all(
			slides.map(async (url) => await GetUserVideo(url, login))
		)
		song = await getVideo(song, login)

		setSurpriseConfig({ video, slides, song })
		setDisplaySurprise(true)
	}

	/*****************************
	 *  Component configuration
	 * ***************************/

	return (
		<>
			{displaySurprise && (
				<Surprise
					background={worldBG}
					setDisplaySurprise={setDisplaySurprise}
					video={surpriseConfig.video}
					song={surpriseConfig.song}
					slides={surpriseConfig.slides}
					onSurpriseEnded={() => setDisplaySurprise(false)}
				/>
			)}

			{backgroundPath && (
				<UnitNavigation
					moduleName="MODULE5"
					module={module5}
					days={DAYS_CONFIG}
					totalDays={9}
					unitDestiny="/unit1"
					nextDestiny="/unit2"
					backgroundPath={backgroundPath}
					onSurpriseClick={handleSurpriseClick}
					unit={1}
					animal={MediaService.getImage('/Images/Button_BirdHead.png', login)}
				/>
			)}
		</>
	)
}
export default Module5Nav
